module.exports = __webpack_public_path__ + "media/src/images/mypage/icon_twitter-e0827f1b2ea0de1f86943612d7570659.png";